/* eslint-disable id-length */
import moment from "moment";
import { getMicrosecondDurationFormattedString } from "app/lib/date";
import { TimePeriod } from "../Renderer";

export type Dataset = { [key: string]: number }[];

export function getLatestValue(dataset: Dataset, attribute = "y") {
  return dataset.at(-1)?.[attribute] ?? 0;
}

export function getOldestValue(dataset: Dataset, attribute = "y") {
  return dataset.at(0)?.[attribute] ?? 0;
}

export function calculateMin(dataset: Dataset, attribute = "y") {
  return dataset.reduce(
    (min, current) => (current[attribute] < min ? current[attribute] : min),
    Infinity,
  );
}

export function calculateMax(dataset: Dataset, attribute = "y") {
  return dataset.reduce(
    (max, current) => (current[attribute] > max ? current[attribute] : max),
    -Infinity,
  );
}

export function calculateSum<TData extends { [key: string]: number | null }>(
  dataset: TData[],
  attribute: keyof TData = "y",
): number {
  return dataset.reduce((sum, current) => {
    if (current[attribute] === null) {
      return sum;
    }
    // @ts-expect-error - TS2531
    return sum + current[attribute];
  }, 0);
}

export function calculateAverage(dataset: Dataset, attribute = "y") {
  return (
    dataset.reduce((previous, current) => {
      return previous + current[attribute];
    }, 0) / dataset.length
  );
}

export function formatDuration(ms: number) {
  if (ms === 0) {
    return 0;
  }
  return getMicrosecondDurationFormattedString(ms * 1000);
}

// Ex. Jan 1, 18:35pm
export function formatTooltipDateString(time: number) {
  return moment(time).format("MMM D, H:mma");
}

export function formatPercentage(percentage: number) {
  return new Intl.NumberFormat("default", {
    style: "percent",
    maximumFractionDigits: 2,
  }).format(percentage / 100);
}

export function getTimePeriodString(timePeriod: TimePeriod) {
  switch (timePeriod) {
    case TimePeriod.Hour:
      return "Last hour";
    case TimePeriod.Day:
      return "Last 24 hours";
    case TimePeriod.Week:
      return "Last 7 days";
  }
}
